module.exports = __webpack_public_path__ + "static/media/pie.b9d9cb40.png";